import { ApiProperty } from "@nestjs/swagger";

export class RackZoneEndCustResponse{
    @ApiProperty()
    endCustomerId:number;
}